import { createSubscriber, IEvent, IConsumer, createConsumer } from '@cian/events-log';
import { openAuthModal } from 'browser/services/microfrontendsAPI/header';

import { fetchUser as refetchUser } from '../fetchUser';
import { IApplicationContext } from '../../types/applicationContext';

export interface IRequestAuthenticationParameters {
  onSuccess?(): void;
  onCloseNoAuth?(): void;
}

const TOPIC_USER = 'user';

type TConsumerSingleton = (() => IConsumer) & { _instance?: IConsumer };

const getUserConsumer: TConsumerSingleton = (): IConsumer => {
  if (!getUserConsumer._instance) {
    getUserConsumer._instance = createConsumer({ topic: TOPIC_USER });
  }

  return getUserConsumer._instance;
};

export const requestAuthentication = (context: IApplicationContext, parameters?: IRequestAuthenticationParameters) => {
  const consumer = getUserConsumer();

  const userSubscriber = createSubscriber(async (event: IEvent<unknown>) => {
    if (event.type === 'authenticated') {
      await refetchUser(context, {});

      if (window.__reloadHeader__) {
        window.__reloadHeader__();
      }

      if (parameters && parameters.onSuccess) {
        parameters.onSuccess();
      }

      consumer.unsubscribe(userSubscriber);

      return;
    }

    if (event.type === 'authentication_modal_closed') {
      if (parameters && parameters.onCloseNoAuth) {
        parameters.onCloseNoAuth();
      }

      consumer.unsubscribe(userSubscriber);
    }
  });

  consumer.subscribe(userSubscriber);

  void openAuthModal({
    alert: null,
    autoRefresh: false,
    source: null,
    useDefaultView: false,
    viewData: null,
  });
};
